import React, { useEffect, useState } from "react";
import './ButtonTop.css';
// fontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

const ButtonTop = () => {
    const [showBtnTop, setShowBtnTop] = useState(false);

    useEffect( () => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            scrollPosition > 500 ? setShowBtnTop(true) : setShowBtnTop(false);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return(
        <>
            <div className={`buttontop ${showBtnTop ? 'visible' : ''}`}>
                <a href="#home">
                    <FontAwesomeIcon icon={faArrowUp} /> 
                </a>
            </div>   
        </>
    )
}

export default ButtonTop;